module.exports = __webpack_public_path__ + "static/media/System_Boundary-flooring.c2b7bf9e.png";